export const SET_POLICIES = "SET_POLICIES";
export const RESET_POLICIES = "RESET_POLICIES";
export const SET_SPECIFIC_POLICIES = "SET_SPECIFIC_POLICIES";
export const RESET_SPECIFIC_POLICIES = "RESET_SPECIFIC_POLICIES";
